export default __webpack_public_path__ + "static/warrior-3c81ed3d263e2ab3d09cccbf29a92cf9.jpg";